import React from 'react';
import PropTypes from 'prop-types';

import TourCardImage from 'app/shared/components/postingPath/TourCard/TourCardImage';
import TourCardDetails from 'app/shared/components/postingPath/TourCard/TourCardDetails';
import TourCardEditableControls from 'app/shared/components/postingPath/TourCard/TourCardEditableControls';
import TourCardEmpty from 'app/shared/components/postingPath/TourCard/TourCardEmpty';

import {
    StyledContainerDiv,
    StyledContentDiv,
    StyledDiv,
} from './StyledComponents';

const propTypes = {
    tour: PropTypes.shape({
        name: PropTypes.string.isRequired,
        createdDate: PropTypes.string.isRequired,
        creatorName: PropTypes.string.isRequired,
        imageSrc: PropTypes.string,
        state: PropTypes.oneOf(['active', 'inactive', 'empty']),
    }).isRequired,
    tourType: PropTypes.oneOf(['amenity', 'floorPlan', 'unit', 'singleFamily']).isRequired,
    isDisabled: PropTypes.bool.isRequired,
    formData: PropTypes.object.isRequired,
    updateStatusMessage: PropTypes.func.isRequired,
    updateFormData: PropTypes.func.isRequired,
};

const TourCardEditableHorizontal = ({
    tour,
    tourType,
    isDisabled,
    showPublish,
    floorPlanIndex,
    unitIndex,
    formData,
    updateStatusMessage,
    updateFormData,
}) => (
    <StyledDiv className="TourCardEditableHorizontal">
        <StyledContainerDiv>
            <TourCardImage
                imageSrc={tour.imageSrc}
                tourState={tour.state}
                size="full"
            />
        </StyledContainerDiv>
        <StyledContentDiv>
            {tour.state === 'empty' ? (
                <TourCardEmpty
                    floorPlanIndex={floorPlanIndex}
                    formData={formData}
                    isDisabled={isDisabled}
                    tour={tour}
                    tourType={tourType}
                    unitIndex={unitIndex}
                    updateFormData={updateFormData}
                    updateStatusMessage={updateStatusMessage}
                />
            ) : (
                <React.Fragment>
                    <TourCardDetails tour={tour} size="md" />
                    {!isDisabled && (
                        <TourCardEditableControls
                            floorPlanIndex={floorPlanIndex}
                            unitIndex={unitIndex}
                            tour={tour}
                            size="sm"
                            tourType={tourType}
                            showPublish={showPublish}
                            formData={formData}
                            updateStatusMessage={updateStatusMessage}
                            updateFormData={updateFormData}
                        />
                    )}
                </React.Fragment>
            )}
        </StyledContentDiv>
    </StyledDiv>
);

TourCardEditableHorizontal.propTypes = propTypes;

export default TourCardEditableHorizontal;
